import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalHeader, Row, Col, Input } from 'reactstrap';
import i18n from '../../i18next';

import { loadJobPayload, loadJobItems } from '../../actions/index';
import MainJobDetails from './MainJobDetails';
import SubJobsDetails from './SubJobsDetails';
import { MULTI } from '../../utils/Constants';

class JobDetailsScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedJob: {
                id: -1,
                action: '',
                duration: null,
                restaurantName: '',
                scheduledAt: '',
                startedAt: '',
                status: '',
                type: '',
                userName: '',
                jobPayloadData: '',
                jobItems: []
            },
            stateAlreadyCopiedFromProps: false,
        }

        this.toggle = this.toggle.bind(this);
    }

    manageStateOnRender() {
        if (this.props.isOpen) {
            if (this.props.selectedJob !== undefined && this.props.selectedJob !== null &&
                this.props.selectedJob.id !== undefined && this.props.selectedJob.id !== -1 &&
                !this.state.stateAlreadyCopiedFromProps) {

                this.props.loadJobPayload(this.props.selectedJob.id);

                if (this.props.selectedJob.type === MULTI) {
                    this.props.loadJobItems(this.props.selectedJob);
                }

                this.copyStateFromProps();
            }
        } else {
            this.resetModalState();
        }
    }

    copyStateFromProps() {
        this.setState({
            selectedJob: {
                id: this.props.selectedJob.id,
                action: this.props.selectedJob.action,
                duration: this.props.selectedJob.duration,
                restaurantName: this.props.selectedJob.restaurantName,
                scheduledAt: this.props.selectedJob.scheduledAt,
                startedAt: this.props.selectedJob.startedAt,
                status: this.props.selectedJob.status,
                type: this.props.selectedJob.type,
                userName: this.props.selectedJob.userName,
                jobPayloadData: this.props.jobPayload,
                jobItems: this.props.jobItems
            },
            stateAlreadyCopiedFromProps: true
        });
    }

    toggle() {
        this.props.onToggle();
        this.resetModalState();
    }

    resetModalState() {
        this.state.selectedJob.id = -1;
        this.state.selectedJob.action = '';
        this.state.selectedJob.duration = null;
        this.state.selectedJob.restaurantName = '';
        this.state.selectedJob.scheduledAt = '';
        this.state.selectedJob.startedAt = '';
        this.state.selectedJob.status = '';
        this.state.selectedJob.type = '';
        this.state.selectedJob.userName = '';
        this.state.selectedJob.jobPayloadData = '';
        this.state.selectedJob.jobItems = [];
        this.state.stateAlreadyCopiedFromProps = false;
    }

    renderPayloadData() {
        const { textareaStyle, emptyTextAreaMsg } = styles;

        if ((this.props.jobPayload.length !== undefined && this.props.jobPayload.length > 0)
            || Object.keys(this.props.jobPayload).length > 0) {
            return (
                <Input type="textarea" name="text" value={JSON.stringify(this.props.jobPayload, null, 2)} style={textareaStyle} />
            );
        } else {
            return (
                <Input type="textarea" name="text" value={i18n.t('screens:jobDetailsScreen.noContent')} style={emptyTextAreaMsg} />
            );
        }
    }

    renderLoadingPayloadMessage() {
        const { emptyTextAreaMsg } = styles;

        return (
            <Input type="textarea" name="text" value={this.props.jobPayload} style={emptyTextAreaMsg} />
        );
    }

    renderJobDetails() {
        const { payloadText, selectedJobStyle } = styles;

        if (this.state.selectedJob.type == MULTI) {
            return (
                <div>
                    <p style={selectedJobStyle}>{i18n.t('screens:jobDetailsScreen.masterJob')} </p>
                    <MainJobDetails selectedJob={this.state.selectedJob} />
                    <SubJobsDetails jobItems={this.props.jobItems} selectedJob={this.state.selectedJob} jobPayload={this.props.jobPayload} isOpen={this.props.isOpen} />
                </div>
            )
        } else {
            return (
                <div>
                    <MainJobDetails selectedJob={this.state.selectedJob} />
                    <Row>
                        <Col xs={12} sm={6} style={payloadText}>{i18n.t('screens:jobDetailsScreen.payload')}:</Col>
                        <Col xs={12} sm={12}>
                            {(this.props.jobPayload == i18n.t('actions:jobPayloadActions.loadingPayload')) ? this.renderLoadingPayloadMessage() : this.renderPayloadData()}
                        </Col>
                    </Row>
                </div>
            );
        }
    }

    render() {
        this.manageStateOnRender();

        const { modalBodyText } = styles;

        return (
            <div>
                <Modal isOpen={this.props.isOpen} size="lg">
                    <ModalHeader className="modalHeader" toggle={this.toggle} >{i18n.t('screens:jobDetailsScreen.job')}</ModalHeader>
                    <ModalBody style={modalBodyText}>
                        {this.renderJobDetails()}
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        jobPayload: state.jobPayload,
        jobItems: state.jobItems
    };
};

export default connect(mapStateToProps, { loadJobPayload, loadJobItems })(JobDetailsScreen);

let styles = {
    modalBodyText: {
        fontSize: 14,
        height: 600,
        overflowY: 'auto'
    },
    textareaStyle: {
        height: 340
    },
    emptyTextAreaMsg: {
        height: 340,
        color: '#7c7c7c',
        fontStyle: 'italic'
    },
    payloadText: {
        marginBottom: 10
    },
    selectedJobStyle: {
        fontSize: 16,
        borderBottom: '1px solid #ced4db'
    }
}


// WEBPACK FOOTER //
// ./src/components/jobhistory/JobDetailsScreen.js